export default __webpack_public_path__ + "3ed9d6f9d358aadd6d3057db4c737f32.svg";